define('views/parts/menu/menu-item',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // templates
    'text!templates/parts/menu/menu-action.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TMenuAction
) {

    /**
     * Private view for the items of the generic menu view.
     *
     * Triggers a 'item:click' event on click and pass the item's model with it.
     * Best use of the model would be to add a callback to it before passing it to the menu.
     *
     * It's possible to pass the 'toggle' property on single menu item (model).
     *
     * @param  {Boolean} toggle - if it should apply the 'active' class on click. Default to false.
     * @param  {Boolean} radio - if it should removes other active class before applying the 'active' class on click. Default to false.
     * @param  {string} template - HTML string of the item template.
     * @param  {Backbone.Model} model - the data to use inside the template.
     * @param  {Function|string} callback - when clicked.
     */
    var VMenuItem = Backbone.View.extend({
        template: TMenuAction, // default template
        events: {
            'click': 'onClick'
        },
        regions: {
            tooltip: '[data-toggle="tooltip"]',
            content: '.content',
            buttonElement: '.btn-link-element',
        },
        initialize: function(opt) {
            this.options = _.extend({
                radio: false,
                toggle: false,
                watchRoute: false
            }, opt);

            if (this.options.templateItem) {
                this.template = opt.templateItem;
            }

            this.listenTo(this.model, {
                'change:route': this.render,
                'change:active': this.renderClass,
                'toggle:active': this.setActive,
                'change:disabled': this.onDisabledChange,
                'change:content': this.onContentChange,
                'change:badge': this.render,
                'remove': this.remove
            });
        },

        initListener: function() {
            this.stopListeningTo(Backbone.history);
            if (this.isWatchingRoute()) {
                this.listenTo(Backbone.history, {
                    "route": this.onRoute
                });
            }
        },
        render: function() {
            this.initListener();
            if (this.hasTooltip()) {
                this.$(this.regions.tooltip).tooltip('destroy');
            }

            var data = Mustache.getContext(this.model.toJSON(), this.options.namespace),
                $html = Backbone.$(Mustache.render(this.template, data));

            this.$el.replaceWith($html);
            this.setElement($html);

            this.generateZones();

            this.renderClass();

            if (this.hasTooltip()) {
                this.zone.$tooltip.tooltip(this.options.tooltip);
            }

            this.checkRoute();
            return this;
        },

        renderClass: function() {
            var model = this.model;
            this.$el.toggleClass('empty', this.isEmpty())
                .toggleClass('active', this.isActive())
                .toggleClass('highlighted', this.isHighlighted())
            this.toggleDisabled(model.get('disabled'));

            if (model.has('className')) {
                this.$el.addClass(model.get('className'));
            }
        },

        setActive: function(val) {
            if (!this.isActive() && this.options.radio && Boolean(val)) {
                // trigger to deactivate other menu item
                this.model.trigger('reset:active');
            }
            this.model.set('active', Boolean(val));
            this.$el.toggleClass('active', this.isActive());
        },

        toggleActive: function(val) {
            this.setActive(val === undefined ? !this.isActive() : val);
        },

        isActive: function() {
            return Boolean(this.model.get('active'));
        },

        isHighlighted: function() {
            return Boolean(this.model.get('highlight'));
        },

        isEmpty: function() {
            return Boolean(this.model.get('empty'));
        },

        isWatchingRoute: function() {
            return Boolean(this.model.has('route') && (this.options.watchRoute || this.model.get('watchRoute')));
        },

        checkRoute: function() {
            if (this.isWatchingRoute()) {
                this.toggleActive(Backbone.history.hasPrefix(this.model.get('route')));
            }
        },

        hasTooltip: function() {
            return Boolean(this.options.tooltip);
        },

        toggleDisabled: function(val) {
            this.$el.toggleClass('disabled', _.isUndefined(val) ? false : val);
            this.zone.$buttonElement.toggleClass('disabled', _.isUndefined(val) ? false : val);
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            var opt = this.options,
                item = this.model,
                isRadio = opt.radio,
                isToggle = opt.toggle || item.get('toggle');

            if (item.get('disabled') || this.$el.hasClass('disabled')) {
                e.preventDefault();
                return;
            }

            if (this.isEmpty() || this.isActive() && isRadio && !isToggle) {
                return; // early return
            }

            if (isRadio || isToggle) {
                this.toggleActive();
            }

            // inactive or it doesn't matter
            item.trigger('item:click', e, item, opt.menu);

            _.callback(item.get('context') || opt.context || this, item.get('callback'), [
                e, item, opt.menu
            ]);

        },

        onDisabledChange: function(model, value) {
            this.toggleDisabled(value);
        },

        onContentChange: function(model, value) {
            if (this.options.skipTranslation) {
                this.zone.$content.html(value);
            } else {
                this.zone.$content.html(Mustache.render('{{#t}}{{content}}{{/t}}', Mustache.getContext({
                    content: value
                })));
            }
        },

        /**
         * Triggers on route change: http://backbonejs.org/#Events-catalog
         * Only triggers if `watchRoute` is set to true.
         */
        onRoute: function(router, route, params) {
            this.checkRoute();
        },

        onDisable: function() {
            this.stopListeningTo(Backbone.history);
        },

    });

    return VMenuItem;

});

